'use strict';

var React = require('react');
var Select = require('react-select');
var _ = require('lodash');
var InvestmentAllocationActions = require('../../actions/InvestmentAllocationActions');
var ApplicationActions = require('../../actions/ApplicationActions');
var Constants = require('../../constants/InvestmentAllocationConstants');

var modelData = [];

var filterOptionsHandler = function (options, filterString) {
    try {

        if (filterString != '') {
            if (filterString.length >= 3) {
                options = modelData;
                options = options.filter(function (string) {
                    filterString = filterString.toLowerCase();
                    return string.value.toString().toLowerCase().indexOf(filterString) > -1 ||
                        string.label.toLowerCase().indexOf(filterString) > -1;
                });
            }
        }

    }
    catch (err) {
        console.error('Model Portfolio search->filterOptionsHandler()=> Err: ' + err);
    }

    return options;
};
var ModelPortfolio = React.createClass({

    //Gets the selected model portfolio and its investment option
    getSelectedData: function (code, modelData) {
        var dataInfo = _.find(modelData, { value: code });
        return dataInfo;
    },

    //Gets the index of the selected model portfolio
    getIndexOfSelectedData: function (code, modelData) {
        var dataInfo = _.indexOf(modelData, _.find(modelData, { value: code }));
        return dataInfo;
    },

    addToInvestmentOption: function (portfolioCode) {

        var data = this.getSelectedData(portfolioCode, modelData),
            selectedModelData, investmentList = [];

        if (data) {
            selectedModelData = this.getIndexOfSelectedData(portfolioCode, modelData);

            _.forEach(data.investmentOptions, function (n) {
                investmentList.push({
                    id: n.id,
                    name: n.name,
                    code: n.code,
                    weight: n.weight.toFixed(2),
                    termDeposit: n.termDeposit,
                    fmsCode: n.fmsCode,
                    rebatePaymentOption: n.rebatePaymentOption,
                    groupSequenceNumber: n.groupSequenceNumber,
                    redemptionSequenceNumber: n.redemptionSequenceNumber,
                    isFirstRateInvestment: n.isFirstRateInvestment,
                    isManagedAccountOrModelPortfolio: true
                });
            });

            InvestmentAllocationActions.clearInvestmentOptions();
            InvestmentAllocationActions.addInvestmentOptions(investmentList);
            InvestmentAllocationActions.selectModelPortfolio(selectedModelData);
            ApplicationActions.sendInvestmentOptions(_.clone(this.props.allocatedInvestmentOptions));
        }
    },

    handlefilterOptions: function (options, filterString) {
        return filterOptionsHandler(options, filterString);
    },

    render: function () {
        modelData = this.props.modelPortfolioList;

        //we need to convert this part otherwise unit test will fail
        var active = false;
        if (this.props.isDisable) {
            active = true;
        }

        return (
            <div className="model-portfolio-search">
                <Select name="form-field-name"
                        options={this.props.modelPortfolioList}
                        onChange={this.addToInvestmentOption}
                        placeholder={this.props.placeholderText}
                        value={this.props.selectedModelPortfolio}
                        filterOptions={this.handlefilterOptions}
                        disabled={active}
                        clearable={false}
                        className="select-input-lg"
                        inputProps={{id: 'model-portfolio-search'}} />
                 <div className="form-label-section">
                    <label>{Constants.PlaceHolderMessage.TRIS_OPTIONS}</label>
                 </div>
            </div>
		);
    }
});

module.exports = ModelPortfolio;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/InvestmentAllocation/ModelPortfolio.jsx